import {Routes} from '@angular/router';
import {
  RealEstateLeasingBaseInfoSectionComponent
} from './sections/real-estate-leasing-base-info-section/real-estate-leasing-base-info-section.component';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {SessionService} from '../../../../services/ssession.service';

export const desktopStages: string[] = [
  'Informacje podstawowe',
  'Dane identyfikacyjne',
  'Zgody',
  'Załączniki'
];

export const mobileStages: string[] = [
  'Informacje podstawowe',
  'Dane identyfikacyjne',
  'Zgody',
  'Załączniki'
];

export const stages: string[] = SessionService.GetUISettings()?.mobileEmbed ? mobileStages : desktopStages;

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages,
  successUrl: '../zgody',
  cancelUrl: '../informacje-podstawowe'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../dane-identyfikacyjne',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const realEstateLeasingDesktopRoutes: Routes = [
  {
    path: 'informacje-podstawowe',
    component: RealEstateLeasingBaseInfoSectionComponent
  },
  {
    path: ':appId/informacje-podstawowe',
    component: RealEstateLeasingBaseInfoSectionComponent
  },
  {
    path: ':appId/dane-identyfikacyjne',
    component: ApplicantDataSectionComponent,
    data: applicantDataSectionConfig
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'informacje-podstawowe', pathMatch: 'prefix'}
];

export const realEstateLeasingMobileRoutes: Routes = [
  {
    path: 'informacje-podstawowe',
    component: RealEstateLeasingBaseInfoSectionComponent
  },
  {
    path: ':appId/informacje-podstawowe',
    component: RealEstateLeasingBaseInfoSectionComponent
  },
  {
    path: ':appId/dane-identyfikacyjne',
    component: ApplicantDataSectionComponent,
    data: {
      ...applicantDataSectionConfig,
      successUrl: '../zgody'
    }
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: {
      ...agreementsDataSectionConfig,
      removeRegulationsControl: true
    }
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'informacje-podstawowe', pathMatch: 'prefix'}
];

export const realEstateLeasingRoutes: Routes = SessionService.GetUISettings()?.mobileEmbed ? realEstateLeasingMobileRoutes : realEstateLeasingDesktopRoutes;
